import mustache from "mustache";
import {
  fx_createTareaRequest,
  fx_createTareaRequestEmpty,
  TareaRequest,
} from "../../../../../modulos/configuracion/rastro/request/TareaRequest";
import { TareaResponse } from "../../../../../modulos/configuracion/rastro/response/TareaResponse";
import { TareaSaveGrpcService } from "../../../../../modulos/configuracion/rastro/services/TareaSaveGrpcService";
import { BaseCreateRender } from "../../../../base/BaseCreateRender";
import { FormCardRender } from "../../../../implementations/card/FormCardRender";
import { TextField } from "../../../../implementations/form/text/TextField";
import template from "./tareaRenameModalTemplate.html";

mustache.parse(template);

/** Modal chico de crear/editar una tarea de rastro (auto-montado sobre
 *  `body`): un solo campo (nombre). `tarea` null = crear; con valor = editar
 *  (siempre del cliente — este endpoint no toca tareas globales). */
export class TareaRenameModal extends BaseCreateRender {
  protected readonly elementId = "tareaRenameModal";

  private readonly _formCard: FormCardRender<TareaRequest, TareaResponse>;

  /**
   * @param clienteId      Cliente dueño de la tarea (para crear).
   * @param tarea          Tarea a editar, o null para crear una nueva.
   * @param onSaveEnd      Notifica la tarea creada/editada (refresco del
   *                       selector).
   * @param nombreInicial  Solo al crear (`tarea` null): precarga el nombre
   *                       con el texto ya escrito en el selector.
   */
  constructor(
    clienteId: string,
    tarea: TareaResponse | null,
    onSaveEnd: (tarea: TareaResponse) => void,
    nombreInicial?: string,
  ) {
    super();
    const request = tarea
      ? fx_createTareaRequest(tarea)
      : { ...fx_createTareaRequestEmpty(clienteId), nombre: nombreInicial ?? "" };
    this._formCard = new FormCardRender<TareaRequest, TareaResponse>(request, {
      cardHeader: { title: tarea ? "Editar tarea" : "Nueva tarea" },
      createFormFields: (req) => [this._createNombre(req)],
      saveService: new TareaSaveGrpcService(),
      submitText: "Guardar",
      cancelAction: () => this.dispose(),
      onSubmitEnd: (saved) => {
        onSaveEnd(saved);
        this.dispose();
      },
    });
  }

  protected getHtml(): string {
    return mustache.render(template, { card: this._formCard.render() });
  }

  protected afterInit(element: HTMLDivElement): void {
    this._formCard.connect();
    this._overlay = element.querySelector<HTMLDivElement>(".sx-modal-overlay");
    this._overlay?.addEventListener("click", this._onOverlayClick);
    requestAnimationFrame(() =>
      this._overlay?.classList.add("sx-modal-overlay--open"),
    );
  }

  protected beforeDispose(_element: HTMLDivElement): void {
    this._overlay?.removeEventListener("click", this._onOverlayClick);
    this._formCard.dispose();
  }

  private _overlay: HTMLDivElement | null = null;

  private _onOverlayClick = (e: MouseEvent): void => {
    if (e.target === this._overlay) this.dispose();
  };

  private _createNombre(request: TareaRequest): TextField<TareaRequest> {
    return new TextField<TareaRequest>(
      request,
      {
        label: "Nombre",
        type: "text",
        description: "Nombre de la tarea (único entre las del cliente).",
        get: (r) => r.nombre,
        set: (r, value) => {
          r.nombre = value;
        },
      },
      { isRequired: true, maxLength: 50 },
    );
  }
}
